"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityTypes = {
    native: 1,
    converted: 2,
    conquest: 3
};
